<template>
  <el-dialog
    id="edit-modal"
    class="form-modal"
    :visible.sync="orderDetailVisible"
    v-loading="actionProcessing"
    :fullscreen="true"
    :show-close="false"
    :modal="false"
  >
    <div id="edit-modal-header" class="modal-header">
      <div class="modal-header-layout flex grid-6 align-center">
        <h1 class="modal-title col-2">View Order Details</h1>
        <div class="modal-actions col-2">
          <el-button
            type="default"
            class="hidden-xs-only"
            @click="closeDialog"
          >
            Close
          </el-button>
          <el-button
            type="default"
            icon="el-icon-close"
            class="hidden-sm-and-up"
            @click="closeDialog"
          />
        </div>
      </div>
    </div>

    <div class="dialog__body">
      <el-form>
        <div
          v-if="(orderStatus === 'Pending' && !allFOC)"
          class="inline-form-group order-actions"
        >
          <el-button type="primary" @click="approveOrder">Approve</el-button>
          <el-button type="warning" @click="rejectOrder">Reject</el-button>
        </div>

        <div class="inline-form-group">
          <el-col :span="11">
            <el-input v-model="customerOrderReference" readonly disabled>
              <template slot="prefix">Customer Order Reference</template>
            </el-input>
          </el-col>
          <el-col :span="2"> </el-col>
          <el-col :span="11">
            <el-input v-model="orderStatus" readonly disabled>
              <template slot="prefix">Order Status</template>
            </el-input>
          </el-col>
        </div>
        <div class="inline-form-group">
          <el-col :span="11">
            <el-input v-model="desiredDueDate" readonly disabled>
              <template slot="prefix">Desired Due Date</template>
            </el-input>
          </el-col>
          <el-col :span="2"> </el-col>
          <el-col :span="11">
            <el-input v-model="tenantId" readonly disabled>
              <template slot="prefix">Account name</template>
            </el-input>
          </el-col>
        </div>

        <h2 class="form-section-header pb-10">
          Customer Details
        </h2>

        <div class="inline-form-group">
          <el-col :span="11">
            <span class="black-text"><strong>Auth name</strong> <br> {{ authName }}</span>
          </el-col>
          <el-col :span="2" />
          <el-col :span="11">
            <span class="black-text"><strong>Account number</strong> <br> {{ accountNum }}</span>
          </el-col>
        </div>

        <div class="inline-form-group pt-10">
          <el-col :span="11">
            <span class="black-text"><strong>Address</strong><br> {{ address }} <br> {{ cityStateZip }}</span>
          </el-col>
          <el-col :span="2" />
          <el-col :span="11">
            <span class="black-text"><strong>Account pin</strong> <br> {{ accountPin }}</span>
          </el-col>
        </div>

        <h2 class="form-section-header">Port Out Numbers</h2>
        <div class="vxe-table">
          <vxe-grid
            round
            class="tn-groups-table"
            border="inner"
            height="350px"
            auto-resize
            show-overflow="tooltip"
            empty-text="No Data"
            :scroll-y="{ enabled: true, gt: 50, oSize: 0 }"
            :data="tnGroups"
            :columns="tableColumns"
          />
        </div>
      </el-form>

      <el-dialog
        :visible.sync="rejectReasonModalVisible"
        width="350px"
        :close-on-click-modal="false"
      >
        <el-form>
          <h2 class="form-section-header">
            Provide reject reason
          </h2>
          <el-select
            v-model="rejectReason"
          >
            <el-option
              value="PIN"
              label="Pin required/invalid"
            />
            <el-option
              value="DATAMIS"
              label="All data mismatch"
            />
            <el-option
              value="AUTHNMMIS"
              label="Auth name mismatch"
            />
            <el-option
              value="INVACCT"
              label="Invalid account number"
            />
            <el-option
              value="INVZIPCD"
              label="Invalid zip code"
            />
          </el-select>
          <el-button @click="processReject">
            Submit
          </el-button>
        </el-form>
      </el-dialog>

    </div>
  </el-dialog>
</template>

<script>
import feathersClient from "@/feathers/feathers-client";
import moment from 'moment-timezone';
import {phoneNumberFormatter} from "@/globals/globals";

export default {
  name: "OrderDetail",

  props: {
    orderDetailVisible: { required: true },
    selectedOrder: { required: true }
  },

  data() {
    return {
      actionProcessing: false,
      rejectReasonModalVisible: false,
      rejectReason: '',
      authName: '',
      accountPin: '',
      accountNum: '',
      address: '',
      cityStateZip: '',
      allFOC: true,
      tableColumns: [
        { type: "seq", width: 40 },
        {
          field: "telephoneNumber",
          title: "Telephone Number",
          minWidth: "120",
          sortable: true,
          slots: {
            default: ({ row }) => {
              return [<span>{this.numberFormatter(row.telephoneNumber)}</span>];
            }
          }
        },
        {
          field: 'tnStatus',
          title: 'Status',
          minWidth: 150,
          sortable: true
        }
      ],
      customerOrderReference: "20028383",
      orderStatus: "Pending",
      desiredDueDate: "2020/12/07",
      tenantId: 37,
      tnGroups: [
        {
          telephoneNumber: "1928383845",
          tnStatus: "pending",
          tnGroup: "Test",
          name: "Voxo"
        }
      ]
    };
  },

  watch: {
    selectedOrder(val) {
      if (val && val.orderDetail) {
        const {
          customerOrderReference,
          orderStatus,
          desiredDueDate,
          tnGroups
        } = val.orderDetail;

        const {tenantId} = val;

        this.tnGroups = tnGroups;

        if(tnGroups.length){
          const {accountNum, accountPin, authName, streetName, streetNum, postalCode, state, city} = tnGroups[0];

          this.accountNum = accountNum;
          this.accountPin = accountPin;
          this.authName = authName;
          this.address = `${streetNum} ${streetName}`;
          this.cityStateZip = `${city}, ${state} ${postalCode}`;
        }

        for(let i = 0; i < tnGroups.length; i++){
          const {tnStatus} = tnGroups[i];

          if(tnStatus !== `FOC'd`){
            this.allFOC = false;
            break;
          }
        }

        this.customerOrderReference = customerOrderReference;
        this.orderStatus = orderStatus;
        this.desiredDueDate = moment(desiredDueDate).format('YYYY-MM-DD');
        this.tenantId = tenantId;

      }
    }
  },

  methods: {

    approveOrder() {
      this.actionProcessing = true;
      feathersClient.service('port-out-orders').patch(this.selectedOrder.id,  {
        actionType: "approve",
        orderId: this.selectedOrder.orderDetail.id
      })
        .then(() => {
          this.actionProcessing = false;
          this.$notify({
            title: "Success",
            message: "Order approval submitted",
            type: "success"
          });
          this.closeDialog();
        })
        .catch(() => {
          this.actionProcessing = false;
          this.$notify({
            title: "Failed",
            message: "Could not approve order",
            type: "error"
          });
        });
    },

    rejectOrder() {
      this.rejectReasonModalVisible = true;
    },

    processReject(){

      if(!this.rejectReason){
        this.$notify({
          title: 'Invalid',
          message: 'You must submit a reject reason',
          type: 'error'
        });
        return;
      }

      this.rejectReasonModalVisible = false;
      this.actionProcessing = true;
      feathersClient.service('port-out-orders').patch(this.selectedOrder.id, {
        actionType: "reject",
        orderId: this.selectedOrder.orderDetail.id,
        telephoneNumbers: this.tnGroups.map(item => item.telephoneNumber),
        rejectReason: this.rejectReason
      })
        .then(() => {
          this.actionProcessing = false;
          this.$notify({
            title: "Success",
            message: "Order rejection submitted",
            type: "success"
          });
          this.rejectReason = '';
          this.closeDialog();
        })
        .catch(() => {
          this.actionProcessing = false;
          this.$notify({
            title: "Failed",
            message: "Could not reject order",
            type: "error"
          });
        });
    },

    numberFormatter(number) {
      return number
        ? phoneNumberFormatter(number)
        : number;
    },

    closeDialog() {
      this.$emit("closeDialog");
    }
  }
};
</script>

<style lang="scss" scoped>
.vxe-table {
  max-width: 600px;
  margin: 0 auto;
  margin-top: 10px;
}

.order-actions {
  justify-content: flex-end;
  margin-bottom: 10px;
}
</style>
